import * as React from "react";
import { useSelector } from "react-redux";
import { BrandModel } from "./BrandModel.js";
import * as cls from "./Logo.module.scss";
export { Logo, LogoView };
/**
 * Логотип.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Logo/>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Logo() {
  const { vuzId } = useSelector((state) => state.contract);
  const brand = new BrandModel({});
  brand.setLogo(vuzId);
  return <LogoView brand={brand} />;
}
function LogoView({ brand }) {
  return (
    <a
      className={cls.logo}
      href={brand.home}
      aria-label={brand.name}
      title={brand.name}>
      <img src={brand.logo} alt={brand.name} aria-hidden="true" />
    </a>);
}

